import React, { useState, useEffect } from 'react'
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons'
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Form, Schema } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import reinstatementService from '../../../../../services/Internal/Reinstatement/EI/eiReinstatement.service'
import Issues from '../../../../Shared/Card/Issues';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import RedStar from '../../../../Shared/GenericComponents/RedStar';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function AcknowledgementPage() {
    const push = useNavigate();
    const { StringType } = Schema.Types;
    const sectionId = 9;
    const routes = useSelector(x => x.currentRoutes);
    const reinstatementId = useSelector(x => x.currentApplicationId);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [formModel, setFormModel] = useState({})
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Engineer Intern Reinstatement",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Acknowledgement"
        }
    );
    useEffect(() => {
        reinstatementService.eiGetSection(reinstatementId, sectionId).then((response) => {
            reinstatementService.getIndividualReinstatement(reinstatementId).then((reinstatementData) => {
                setIsUserEditable(reinstatementData.data.status.id == 2)
                entityService.getEntity(response.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: reinstatementData.data?.credential?.formattedLicenseNumber,
                            applicationDate: reinstatementData.data?.dateSubmitted,
                            formType: reinstatementData.data?.isOverFiveYears ? "Engineer Intern Reinstatement (5 plus years)" : entityInfo.formType
                        })
                });
            });
            setFormModel(response.data);
            setIsComplete(response.data.staffReviewComplete)
            setHasLoaded(true)
        })
    }, [])
    const model = Schema.Model({
        electronicSignature: StringType().isRequired('This field is required.')
    });

    const formSubmit = (validation, event) => {
        reinstatementService.eiPostSection(reinstatementId, sectionId, formModel.electronicSignature).then((response) => {
            reinstatementService.eiMarkSectionComplete(reinstatementId, sectionId, isComplete).then((val) => {
                if (response.data.id) {
                    nextSectionNavigation();
                }
            });
        })
    }

    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
    }
    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Form readOnly={!isUserEditable} model={model} fluid formValue={formModel} onChange={formModel => setFormModel(formModel)} onSubmit={formSubmit}>
                    {hasLoaded ?
                        <>
                            <Card>
                                <Card.Header><h6>Acknowledgement</h6></Card.Header>
                                <Card.Body>
                                    <p>I, the applicant named in this application, have read the contents hereof, and to the best of my knowledge, information and believe the statements and information in this application are true and correct in substance and effect and are made in good faith. I have not omitted any information requested in this application. I am aware that such an omission or untrue response may constitute fraud or deceit, material misstatement, perjury or the giving of false or forged evidence under Louisiana Revised Statutes 37:698 and 37:700. I understand and agree that any responses verifying my education, personal references, and experience shall be considered privileged and confidential and that this information was not reviewed by me nor will it be available for my inspection or review in the future.</p>
                                    <br />
                                    <ul>
                                        <li>It is your responsibility to check your LOLA account frequently for any pending issues. Ensure you add "lapels.com" to your "Safe Senders" list in your email application and/or (if applicable) in your network firewall.</li>
                                        <li>Once we receive a complete application, with no pending issues, process time may take 6-8 weeks.  </li>
                                        <li>
                                            I certify that all information provided in this online reinstatement is true and correct to the best of my knowledge, information and belief.
                                        </li>
                                        <li>
                                            I am aware that an omission or untrue response may constitute fraud, deceit, material misstatement, perjury or the giving of false or forged evidence under Louisiana Revised Statutes 37:698 and 37:700
                                        </li>

                                        <li>
                                            <b className="colorRed">IMPORTANT: Payments are non-refundable.</b> If you believe that you will be reimbursed for your fee, verify this BEFORE proceeding further
                                        </li>
                                        <li>
                                            If you are unsure about getting reimbursed by your firm, please stop the application process here and come back after you verify. Your answers will be saved.
                                        </li>
                                    </ul>
                                    <hr />
                                    <Row>
                                        <Col sm={4}>
                                            <h5>Electronic Signature of Applicant:<RedStar /></h5>
                                            <span>(Type full name)</span>
                                        </Col>
                                        <Col sm={8}><Form.Control name="electronicSignature" /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <br />
                            <Issues isUserEditable={isUserEditable} isInternal={true} type={2} sectionId={formModel.id} setIsComplete={setIsComplete} /></> : <LoadingSpinner />
                    }
                    <FormActionButtons
                        isReadOnly={!isUserEditable}
                        nextSectionCallback={nextSectionNavigation}
                        isUserEditable={isUserEditable}
                        backToSectionLink="/internal/eiReinstatement/sections"
                        isComplete={isComplete}
                        isCompleteCallback={setIsComplete}
                        showSectionComplete={true}
                    />
                </Form>
            </Container>
        </div>
    );
}
export default AcknowledgementPage